@if (isDesktop) {
<div class="absolute inset-0 pt-4 pb-4 flex flex-col max-w-5xl mx-auto w-full px-4 sm:px-8 xl:px-0">
  <h3 class="text-lg font-semibold mb-2 shrink-0">{{ '::MyShoppingCart' | abpLocalization }}</h3>

<div class="flex flex-col bg-white relative flex-1 min-h-0 mb-0 rounded-xl border border-gray-100 shadow-md overflow-hidden">
  <div class="overflow-auto flex-1 min-h-0 px-8 pt-6 pb-3 overscroll-contain">
    @for (item of cartItems; track item.wineId) {
    <app-metro-list-card-item [productName]="item.wineName" [imageUrl]="item.imageUrl" [items]="item.quantity"
      [price]="item.unitPrice" [isLoading]="loadingStates[item.wineId] || false"
      [maxAvailable]="wineStock[item.wineId] || 0" [showDeleteButton]="true"
      (itemsChange)="updateQuantity($event, item.wineId)" (removeItem)="removeItemFromCart($event, item.wineId)"
      (deleteItem)="deleteItemFromCart($event, item.wineId)">
    </app-metro-list-card-item>
    }

  </div>

  <div class="shrink-0 h-[280px] px-8 pt-3 pb-4 border-t border-gray-100 bg-white">
    <div class="mb-0">
      <app-coupon-input [orderTotal]="total" [sommelierId]="sommelierUserId" [items]="cartItems" [compact]="true"
        (couponApplied)="onCouponApplied($event)" (couponRemoved)="onCouponRemoved()">
      </app-coupon-input>
    </div>

    <div class="flex justify-between border-t pt-1.5 text-sm leading-5">
      <span class="text-metro-blue">{{ '::SubTotal' | abpLocalization }}</span>
      <span class="font-semibold">${{ subtotal | number:'1.2-2' }}</span>
    </div>

    <div class="flex justify-between text-sm leading-5">
      <span class="text-metro-blue">{{ '::Tax' | abpLocalization }} (21%)</span>
      <span class="font-semibold">${{ tax | number:'1.2-2' }}</span>
    </div>

    @if (discountAmount > 0) {
    <div class="flex justify-between text-green-600 text-sm leading-5">
      <span>{{ '::Discount' | abpLocalization }} ({{ appliedCouponDisplay }})</span>
      <span class="font-semibold">-${{ discountAmount | number:'1.2-2' }}</span>
    </div>
    }

    <div class="flex justify-between border-t pt-1.5 mt-1">
      <span class="font-semibold text-lg">{{ '::Total' | abpLocalization }}</span>
      <span class="font-semibold text-lg">${{ totalWithDiscount | number:'1.2-2' }}</span>
    </div>

    <div class="flex justify-center mt-4">
      <app-metro-button class="w-full md:w-auto" [disabled]="total <= 0" [text]="'::Confirm' | abpLocalization"
        (click)="goToOrderConfirm()">
      </app-metro-button>
    </div>
  </div>
</div>
</div>
} @else {
<div class="flex flex-col max-w-5xl mx-auto bg-white fixed top-[calc(4rem_+_env(safe-area-inset-top,0px))] bottom-[calc(4rem_+_env(safe-area-inset-bottom,0px))] left-0 right-0 z-10">
  <div class="relative z-50">
    <app-mobile-communication-banner></app-mobile-communication-banner>
  </div>

  <h3 class="text-lg font-semibold pl-4 mb-1 pt-6 shrink-0">{{ '::MyShoppingCart' | abpLocalization }}</h3>
  <div class="overflow-auto flex-1 min-h-0 pr-2 overscroll-contain pb-4">
    @for (item of cartItems; track item.wineId) {
    <app-metro-list-card-item [productName]="item.wineName" [imageUrl]="item.imageUrl" [items]="item.quantity"
      [price]="item.unitPrice" [isLoading]="loadingStates[item.wineId] || false"
      [maxAvailable]="wineStock[item.wineId] || 0" [showDeleteButton]="true"
      (itemsChange)="updateQuantity($event, item.wineId)" (removeItem)="removeItemFromCart($event, item.wineId)"
      (deleteItem)="deleteItemFromCart($event, item.wineId)">
    </app-metro-list-card-item>
    }
  </div>

  <div class="shrink-0 z-20 bg-white shadow-[0_-4px_10px_rgba(0,0,0,0.05)] border-t border-gray-100 px-4 pt-2 pb-2">
    <div class="mb-0">
      <app-coupon-input [orderTotal]="total" [sommelierId]="sommelierUserId" [items]="cartItems" [compact]="true"
        (couponApplied)="onCouponApplied($event)" (couponRemoved)="onCouponRemoved()">
      </app-coupon-input>
    </div>

    <div class="flex justify-between border-t pt-1.5 mt-1">
      <span class="text-metro-blue">{{ '::SubTotal' | abpLocalization }}</span>
      <span class="font-semibold">${{ subtotal | number:'1.2-2' }}</span>
    </div>

    <div class="flex justify-between">
      <span class="text-metro-blue">{{ '::Tax' | abpLocalization }} (21%)</span>
      <span class="font-semibold">${{ tax | number:'1.2-2' }}</span>
    </div>

    @if (discountAmount > 0) {
    <div class="flex justify-between text-green-600">
      <span>{{ '::Discount' | abpLocalization }} ({{ appliedCouponDisplay }})</span>
      <span class="font-semibold">-${{ discountAmount | number:'1.2-2' }}</span>
    </div>
    }

    <div class="flex justify-between border-t pt-1.5 mt-1.5">
      <span class="font-semibold text-lg">{{ '::Total' | abpLocalization }}</span>
      <span class="font-semibold text-lg">${{ totalWithDiscount | number:'1.2-2' }}</span>
    </div>

    <div class="flex justify-center mt-2">
      <app-metro-button class="w-full" [disabled]="total <= 0" [text]="'::Confirm' | abpLocalization"
        (click)="goToOrderConfirm()">
      </app-metro-button>
    </div>
  </div>
</div>
}
